import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { USER_ACCOUNT_TYPE, UserManager } from '@cakeiteasy/order-process';
import { ngHelper } from '@cakeiteasy/web-utils';
import { AnalyticTracker } from '@analytic/services/analytic-tracker.service';

@Component({
  standalone: false,
  selector: 'user-dropdown-menu',
  templateUrl: './user-dropdown-menu.component.html',
  styleUrls: ['./user-dropdown-menu.component.scss']
})
export class UserDropdownMenuComponent implements OnChanges {
  public profileMainPage: string;
  @Input() toggleExtraClasses: string = '';
  @Input() accountType: string;

  constructor(private _userManager: UserManager,
              private _analyticTracker: AnalyticTracker) {
  }

  ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'accountType', (accountType: string) => {
      this.profileMainPage = accountType === USER_ACCOUNT_TYPE.SHARED_BUSINESS_ACCOUNT ? 'orders-history' : 'my-account';
    });
  }

  public logout() {
    this._analyticTracker.trackLogout();
    this._userManager.logout();
  }
}
